export default __webpack_public_path__ + "static/media/Group8866.8bf2679b.svg";